import React, { useState } from 'react';

// Material
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Type
import { ScheduleInterface } from 'store/ducks/reports/types';
import { GroupingModalOptionsInterface } from 'store/ducks/groupingModal/types';

// Components
import { BackAndForwardControl } from 'components/BackAndForwardControl';
import { MainContent } from 'components';
import { SubmissionSettingsEdit, SubmissionHistory } from './components';
import { TabPanel } from 'components/TabPanel';

// Styles
import useStyles from './LoteDatails.styles';

interface setSubmissionDataInterface {
  submissionData: ScheduleInterface;
  setIsEditSubmissiion: (param: any) => void;
  reportType: string;
  secondReportType?: string;
  reportName: string;
  filterOptions?: string[];
  groupOptions?: GroupingModalOptionsInterface[];
  secondGroupOptions?: GroupingModalOptionsInterface[];
}

const LoteDatails: React.FC<setSubmissionDataInterface> = ({
  submissionData,
  setIsEditSubmissiion,
  reportType,
  secondReportType,
  reportName,
  filterOptions,
  groupOptions,
  secondGroupOptions,
}) => {
  const classes = useStyles();

  const [generalNavGuide, setGeneralNavGuide] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setGeneralNavGuide(newValue);
  };

  return (
    <div className={classes.root}>
      <MainContent className={classes.paperRoot}>
        <BackAndForwardControl
          handleButton={() => setIsEditSubmissiion(false)}
        />
        <Grid
          container
          justifyContent='space-between'
          className={classes.gridContainer}>
          <Grid item>
            <Typography
              variant='h4'
              color='inherit'
              data-testid='relatorio_label'>
              {reportName}
            </Typography>
          </Grid>
        </Grid>
        <Tabs
          indicatorColor='primary'
          onChange={handleChange}
          style={{
            background: '#ffffff',
            marginTop: 10,
          }}
          textColor='primary'
          value={generalNavGuide}>
          <Tab label='Configurações de envio' />
          <Tab label='Histórico de envios' />
        </Tabs>
        <TabPanel index={0} value={generalNavGuide}>
          <SubmissionSettingsEdit
            submissionData={submissionData}
            filterOptions={filterOptions}
            groupOptions={groupOptions}
            secondGroupOptions={secondGroupOptions}
            reportType={reportType}
            secondReportType={secondReportType}
          />
        </TabPanel>
        <TabPanel index={1} value={generalNavGuide}>
          <SubmissionHistory submissionData={submissionData} />
        </TabPanel>
      </MainContent>
    </div>
  );
};

export { LoteDatails };
export default LoteDatails;
